import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kreonetadm.board.item');
import { OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import ClassicEditor from "src/libs/ckeditor/ckeditor";
import $ from "jquery";
import moment from "moment";

@Component({
    selector: 'wiz-portal-kreonetadm-board-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kreonetadm.board.item/view.scss */
.card-header h2 {
  font: normal normal bold 24px/27px NanumSquareOTF;
}

.page-title {
  font: normal normal bold 24px/27px NanumSquareOTF;
  height: 39px;
}

span {
  font: normal normal normal 16px SUIT;
}

.btn-secondary {
  width: 132px;
  height: 44px;
  border-radius: 10px;
}

.btn-outline-blue {
  border-radius: 10px;
}

.text-muted {
  text-align: left;
  font: normal normal normal 18px/21px NanumSquareOTF;
  color: #5D5D5D;
  height: 28px;
}

.workspace-list-header {
  max-width: 1570px;
  width: 95%;
  text-align: center;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1607843137);
  border-radius: 10px;
  margin: 0 auto;
}

.page-header {
  margin-right: auto;
  display: flex;
  flex-direction: row;
  text-align: left;
  height: 39px;
}
.page-header .buttons {
  display: flex;
  flex-direction: row;
  margin-left: auto;
  height: 39px;
  gap: 8px;
}

@media (max-width: 1024px) {
  .text-muted {
    display: none;
  }
}
@media (min-width: 768px) and (max-width: 992px) {
  .workspace-list-header {
    height: auto;
  }
  .page-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
  .buttons {
    display: flex;
    flex-direction: row;
    margin-left: auto;
    gap: 8px;
  }
  button.btn {
    width: auto !important;
    height: auto !important;
  }
}
@media (max-width: 768px) {
  .workspace-list-header {
    height: auto;
  }
  .page-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
  .text-muted {
    display: none;
  }
  .buttons {
    display: flex;
    flex-direction: row;
    margin-left: auto;
    gap: 8px;
  }
  button.btn {
    width: auto !important;
    height: auto !important;
  }
}
@media (max-width: 480px) {
  .workspace-list-header {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
  }
  .page-header {
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 10px;
    height: auto;
  }
  .workspace-list-header::after {
    content: "";
    display: block;
    height: 64px;
  }
  h2.page-title {
    font-size: 18px;
  }
  .text-muted {
    display: none;
  }
}
.form-group {
  padding: 15px 0px;
  border-top: 1px solid #E3E3E3;
}
.form-group .form-label {
  display: flex;
  align-items: center;
  font: normal normal bold 14px/18px SUIT;
  margin-bottom: 0px;
}
.form-group .form-selectgroup-label {
  padding: 7px 16px;
}

.badge {
  width: 84px;
  height: 34px;
  font: normal normal bold 18px/21px NanumSquareOTF;
  text-align: center;
}

.col-auto {
  display: flex;
  flex-direction: row;
}

.dropdown a {
  width: 132px;
  height: 44px;
  border: 1px solid #5263FF;
  border-radius: 10px;
  text-align: left;
  font: normal normal normal 16px/18px NanumSquareOTF;
  margin-left: 1230px;
}

.btn-remove-file {
  height: 30px !important;
  width: 70px !important;
  margin-left: auto;
  border: none;
  background-color: #F6F9FE;
  margin-right: 5px;
}

.btn-outline-blue {
  width: 132px;
  height: 44px;
}

.btn-remove {
  width: 132px;
  height: 44px;
  background: #FF7676;
  color: white;
  border: none;
  border-radius: 10px;
}

.btn-blue {
  width: 132px;
  height: 44px;
  border-radius: 10px;
  margin-left: auto;
}

.btn-md {
  width: 127px;
  height: 44px;
  background: #F2F2F2;
  border-radius: 10px;
  margin-left: auto;
  border: none;
  font: normal normal bold 18px/21px NanumSquareOTF;
  color: #6D6D6D;
}
.btn-md img {
  filter: invert(45%) sepia(0%) saturate(0%) hue-rotate(70deg) brightness(94%) contrast(88%);
}

.btn-save {
  width: 132px;
  height: 44px;
  border-radius: 10px;
  background: #5263ff;
  color: white;
}

.form-selectgroup-input:checked + .form-selectgroup-label {
  z-index: 1;
  color: white;
  background: #5263FF;
  border-color: #5263FF;
}

.form-selectgroup-label {
  height: 44px;
  background: #F2F2F2;
  border-radius: 10px;
  color: #6D6D6D;
  display: flex !important;
  align-items: center;
  border: none;
}

.from-selectgroup-item {
  margin-right: 10px !important;
}

.edit-form {
  padding: 24px 32px;
}

.editor-container {
  width: 1280px;
}

.btn-season {
  background-color: #FE5A33;
  border: 1px solid #FE5A33;
  color: white;
}
.btn-season:hover {
  background-color: #fff;
  border: 1px solid #FE5A33;
  color: #FE5A33;
}

.page-icon.back-btn {
  cursor: pointer;
  background-color: #FE5A33 !important;
}

input,
textarea {
  text-align: left !important;
  border-radius: 0 !important;
}

.card {
  max-width: 1570px;
  width: 95%;
  height: 93%;
  margin: 0 auto;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.1607843137);
  border-radius: 10px;
  border: none;
  overflow: auto;
}

.content {
  padding: 25px;
  width: 100%;
  background-color: white;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
}
.content h2 {
  margin: 0 auto;
  width: 1440px;
  text-align: center;
  font: normal normal bold 36px/41px NanumSquareOTF;
}
.content h4 {
  margin: 10px auto 10px;
  width: 1440px;
  color: #FF7676;
  text-align: center;
}
.content h3 {
  width: 1440px;
  text-align: left;
  border-bottom: solid 1px;
  font: normal normal bold 24px/27px NanumSquareOTF;
}
.content button {
  width: 336px;
  height: 76px;
  font: normal normal normal 24px/27px NanumSquareOTF;
  border: none;
  border-radius: 10px;
}
.content .content-body {
  min-height: 850px;
  background-color: white;
  text-align: left;
}

.table-last {
  width: 1440px;
  margin: 0 auto;
}
.table-last thead {
  border-top: solid 2px #D1D1D1;
  border-bottom: solid 2px #D1D1D1;
  text-align: left;
  font: normal normal bold 17px/19px NanumSquareOTF;
  height: 51px;
}
.table-last tbody tr {
  width: 1440px;
  height: 80px;
  border-bottom: solid 0.5px #D1D1D1;
}
.table-last tbody tr td {
  height: 60px;
  font: normal normal normal 18px/21px NanumSquareOTF;
}

li {
  background: #F6F9FE 0% 0% no-repeat padding-box;
  border-radius: 10px;
  width: 1436px;
  height: 60px;
  display: flex;
  align-items: center;
  text-decoration: underline;
}

img {
  color: #5263FF;
}

.wiz-form {
  margin: 0 auto;
  width: 98%;
  background-color: white;
  font: normal normal normal 18px/21px NanumSquareOTF;
}
.wiz-form .wiz-form-rows {
  min-height: 80px;
}
.wiz-form .wiz-form-label {
  font: normal normal normal 18px/21px NanumSquareOTF;
}

.form-control {
  border-radius: 10px;
}

.season-page {
  position: relative;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  width: 1920px;
  margin: 0px auto;
  border-radius: none;
  vertical-align: middle;
  text-align: left;
}
.season-page .header {
  border-radius: none;
}

.sticky-top {
  padding: 8px 48px;
  position: sticky;
}
.sticky-top .text-align-center {
  justify-content: center;
  align-items: center;
}

.btn-news {
  padding: 12px 30px;
  background: #5263FF 0% 0% no-repeat padding-box;
  font: normal normal normal 16px/18px NanumSquareOTF;
  color: white;
  margin-left: 10px;
}

.btn-gray {
  padding: 12px 30px;
  margin-left: 10px;
  font: normal normal normal 16px/18px NanumSquareOTF;
  color: #000000;
  background-color: #D1D1D1;
  border-radius: 10px;
}

.var {
  align-items: center;
  margin: auto;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(6px);
}

.season-page::-webkit-scrollbar {
  display: none;
}

.content-container {
  padding: 64px auto;
  font-size: 18px;
}
.content-container .content-body {
  max-width: 860px;
  margin: 0 auto;
}

label {
  margin-left: auto;
}

.filebox {
  display: flex;
  justify-content: flex-end;
}

.btn-file {
  width: 127px;
  height: 44px;
  background: #F2F2F2;
  color: #6D6D6D;
  border: none;
  font: normal normal bold 18px/21px NanumSquareOTF;
  border-radius: 10px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-file img {
  filter: invert(45%) sepia(0%) saturate(0%) hue-rotate(70deg) brightness(94%) contrast(88%);
}
.btn-file:hover {
  background: #5263FF;
  color: #fff;
}

#file {
  display: none;
}

li {
  background: #F6F9FE 0% 0% no-repeat padding-box;
  border-radius: 10px;
  border: none;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
}
li a {
  text-decoration: underline;
}
li img {
  filter: invert(17%) sepia(41%) saturate(7462%) hue-rotate(199deg) brightness(89%) contrast(102%);
  width: 20px;
  height: 20px;
}`],
})
export class PortalKreonetadmBoardItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @ViewChild('editor')
    public editorElement: ElementRef;
    public contentEditor: any;
    @Input() post_id: any = "new";
    public category: any = 'notice';
    public fd = new FormData();
    public item: any = {
        user_id: '',
        title: '',
        content: '',
        category: '',
        status: '',
        created: '',
        planstart: '',
        planend: '',
        ended: '',
        files: []
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('admin', '/authenticate');
        await this.init();
    }

    public async init() {

        if (this.post_id == 'new') {
            this.item = {
                category: 'notice',
                status: 'draft',
                title: '',
                content: '',
                featured_image: '',
                created: moment().format("YYYY-MM-DD"),
                files: []
            };

        } else {
            const { code, data } = await wiz.call("get", { id: this.post_id });
            this.item = data;
            this.item.files = JSON.parse(data.files.replace(/'/g, '"'));
            this.item.planstart = moment(this.item.planstart).format("YYYY-MM-DD");
            this.item.planend = moment(this.item.planend).format("YYYY-MM-DD");
        }
        const CONTENT_ID = 'textarea#content';
        const Content = this.item.content || '';
        this.contentEditor = await this.createEditor(CONTENT_ID, Content);
        await this.service.render();
    }

    public async createEditor(selector: string, content: string) {
        const opt = {
            toolbar: {
                items: 'heading | bold italic strikethrough underline | fontColor highlight fontBackgroundColor | bulletedList numberedList todoList | outdent indent | insertTable | link blockQuote code codeBlock'.split(' '),
                shouldNotGroupWhenFull: true,
            },
            removePlugins: ['MediaEmbedToolbar', 'Markdown'],
            table: ClassicEditor.defaultConfig.table,
        };

        const editorInstance = await ClassicEditor.create(document.querySelector(selector), opt);

        if (content) {
            editorInstance.data.set(content);
        } else {
            editorInstance.data.set('');
        }
        const editorElement = editorInstance.ui.getEditableElement();
        editorElement.style.display = 'block';
        return editorInstance;
    }
    public async fileUpload(e) {
        for (let i = 0; i < e.target.files.length; i++) {
            let file = e.target.files[i]
            this.filename = file.name;
            if (!file.filepath) file.filepath = file.name;
            this.fd.append('file[]', file);
            this.item.files.push(file.filepath);
        }
        await this.service.render();
    }

    public async removeFile(i) {
        this.item.files.splice(i, 1)
    }

    public async removeImage() {
        this.item.featured_image = '';
        await this.service.render();
    }

    public async updateImage() {
        let img = await this.service.file.read({ type: 'image', accept: 'image/*', width: 512, quality: 1 });
        this.item.featured_image = img;
        await this.service.render();
    }

    public async update() {
        if (this.contentEditor) {
            this.item.content = this.contentEditor.getData();
        }

        let url = wiz.url('update')
        if (this.item.title.length == 0) {
            await this.alert('제목을 입력해주세요');
            return
        }
        if (this.item.content.length == 0) {
            await this.alert('내용을 입력해주세요');
            return
        }
        this.fd.append('data', JSON.stringify(this.item))
        const { code, data } = await this.service.file.upload(url, this.fd);

        await this.alert('저장되었습니다', '', 'success', '확인');
        await this.service.render();
        this.service.href('/admin/system/notice')
    }

    public async delete() {
        let res: any = await this.alert("정말로 삭제하시겠습니까?", "", "error", "삭제", "취소");
        if (!res) return;
        await wiz.call("delete", { id: this.item.id });
        this.service.href(`/admin/system/notice`);
    }

    public async alert(message: string, title: any = "", status: any = "error", action: string = '확인', cancel: any = false) {
        return await this.service.alert.show({
            title: title,
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

}

export default PortalKreonetadmBoardItemComponent;